class IdleTimer {
  constructor({ timeout, onTimeOut, startCountDown, timmer }) {
    this.timeout = timeout;
    this.onTimeOut = onTimeOut;
    this.startCountDown = startCountDown;
    this.timmer = timmer;
    this.isOpenModal = false;
    this.eventUpdateExpiredTimeHandler = this.updateExpiredTime.bind(this);
    this.tracker();
    this.start();
  }

  updateExpiredTime() {
    if (!this.isOpenModal) {
      setTimeout(() => {
        localStorage.setItem("_expiredTime", Date.now() + this.timeout * 1000);
      });
    }
  }

  tracker() {
    window.addEventListener("mousemove", this.eventUpdateExpiredTimeHandler);
    window.addEventListener("keydown", this.eventUpdateExpiredTimeHandler);
    window.addEventListener("scroll", this.eventUpdateExpiredTimeHandler);
  }
getTimeString(min,sec){
  return (min > 9 ? min.toString() : "0" + min) +
                ":" +
                (sec > 9 ? sec : "0" + sec)
}
  start() {
    this.updateExpiredTime();
    this.interval = setInterval(() => {
      let min = 0,
        sec = 0;
      if (localStorage.getItem("_expiredTime") === null) {
        this.timmer("00:00");
        this.closeModal();
        // if (this.onTimeOut) {
        //   this.onTimeOut();
        //   this.isOpenModal = false;
        //   this.cleanUp();
        // }
        return;
      }

      const expiredTime = parseInt(
        localStorage.getItem("_expiredTime") || 0,
        10
      );
      const currentDate = Date.now();

      if (this.startCountDown) {
        const total = expiredTime - currentDate;
        min = Math.floor((total / 1000 / 60) % 60);
        sec = Math.floor((total / 1000) % 60);
        if (min <= -1 || sec <= -1) {
          this.timmer("00:00");
          this.closeModal()
          // if (this.onTimeOut) {
          //   this.onTimeOut();
          //   this.isOpenModal = false;
          //   this.cleanUp();
          // }
          return;
        }
        if (min <= 3) {
          if (!this.isOpenModal && sec <= 0) {
            this.startCountDown(this.getTimeString(min,sec)
              // (min > 9 ? min.toString() : "0" + min) +
              //   ":" +
              //   (sec > 9 ? sec : "0" + sec)
            );
            this.isOpenModal = true;
          }
          if (this.isOpenModal) {
            this.timmer(this.getTimeString(min,sec)
              // (min > 9 ? min.toString() : "0" + min) +
              //   ":" +
              //   (sec > 9 ? sec : "0" + sec)
            );
          }
        }
      }
      //}

      this.cleanUpOnTimeOut(min,sec)
      // if (min === 0 && sec <= 0) {
      //   if (this.onTimeOut) {
      //     this.onTimeOut();
      //     this.isOpenModal = false;
      //     this.cleanUp();
      //   }
      // }

      //if (expiredTime < currentDate) {
        // if (this.onTimeOut) {
        //     this.onTimeOut();
        //     this.cleanUp();
        // }
      //}
    }, 1000);
  }

 cleanUpOnTimeOut(min,sec){
  if (min === 0 && sec <= 0) {
    this.closeModal()
  }
 }

 closeModal(){
  if (this.onTimeOut) {
    this.onTimeOut();
    this.isOpenModal = false;
    this.cleanUp();
  }
 }

  cleanUp() {
    if (!this.isOpenModal) {
      localStorage.removeItem("_expiredTime");
      clearInterval(this.interval);
      window.removeEventListener(
        "mousemove",
        this.eventUpdateExpiredTimeHandler
      );
      window.removeEventListener("keydown", this.eventUpdateExpiredTimeHandler);
      window.removeEventListener("scroll", this.eventUpdateExpiredTimeHandler);
      this.isOpenModal = false;
    }
  }
}

export default IdleTimer;
